export const navbarDom = {
  root: '.NavBar',
  hamburger: '.NavBarHamburger',
  screen: '.NavScreen',
  close: '.NavScreenClose',
  link: 'a',
  sorting: '.sorting select:not(#search-sorting)',
} as const
